<cap-horizontal-navbar [items]="navItems$ | async"></cap-horizontal-navbar>
